const appStrings: any = {
    couldNotFetchData: 'მონაცემების მიღება ვერ მოხერხდა',
    newApplication: 'ახალი განაცხადი',
    newApplicationTitle: 'ახალი განაცხადის რეგისტრაცია',
    editApplicationTitle: 'განაცხადის კორექტირება',
    applicationDetailsTitle: 'განაცხადის დეტალები',
    deviceSerial: 'აპარატის სერიული',
    fiscalNumber: 'SAM ნომერი',
    sealNumber: 'ხუფის ნომერი',
    taxNumber: 'იდენტიფიკატორი',
    orgName: 'ორგ. სახელი',
    region: 'რეგიონი',
    district: 'რაიონი',
    street: 'ქუჩა',
    addressAdditional: 'სახლი',
    phone: 'ტელეფონი',
    email: 'ელ. ფოსტა',
    activityType: 'საქმიანობის სახე',
    objectType: 'ობიექტის ტიპი',
    samModule: 'SAM მოდული',
    simNumber: 'SIM ნომერი',
    deviceModel: 'აპარატის მოდელი',
    status: 'სტატუსი',
    lastChange: 'ბოლო ცვლილება',
    creatorUser: 'მომხმარებელი',
    readyStatus: 'მოლოდინში',
    inProgressStatus: 'მუშავდება',
    registrationStatus: 'რეგისტრაცია',
    finishedStatus: 'დასრულებული',
    errorStatus: 'შეცდომა',
    deregistrationErrorStatus: 'დერეგ. შეცდომა',
    draftStatus: 'დრაფტი',
    deregisteredStatus: 'დერეგისტრირებული',
    submit: 'გადაგზავნა',
    save: 'შენახვა',
    delete: 'წაშლა',
    deregister: 'დერეგისტრაცია',
    requiredField: 'სავალდებულო ველი',
    mustBeNumber: 'სავალდებულოა რიცხობრივი მნიშვნელობა',
    incorrectFormat: 'არასწორი ფორმატი',
    mustBeEightDigits: 'უნდა შეიცავდეს ზუსტად 8 ციფრს (სფეისის და ასოების გარეშე)',
    invalidSealNumber: 'მინიმუმ 8 სიმბოლო სფეისის გარეშე, მინიმუმ 3 ასო და მინიმუმ 1 ციფრი',
    mustEqualSam: 'SAM ნომერი უნდა ემთხვეოდეს SAM მოდულს',
    mustDifferSamSerial: 'SAM მოდული და აპარატის სერიული არ უნდა ემთხვეოდეს',
    mustDifferSeal: 'ხუფის ნომერი არ უნდა ემთხვეოდეს SAM მოდულს, SAM ნომერს ან აპარატის სერიულს',
    errorSendingDocument: 'განაცხადის რეგისტრაციისას დაფიქსირდა შეცდომა',
    sendDocumentSuccess: 'ახალი განაცხადი წარმატებით დარეგისტრირდა. განაცხადის ID - ',
    couldNotSaveDraft: 'განაცხადის შენახვა ვერ მოხერხდა',
    couldNotDeleteDraft: 'დრაფტის წაშლა ვერ მოხერხდა',
    couldNotDeregister: 'დერეგისტრაცია ვერ მოხერხდა',
    deregistrationStarted: 'განაცხადი გადაიგზავნა დერეგისტრაციაზე',
    draftSaved: 'განაცხადი წარმატებით შეინახა',
    username: 'მომხმარებელი',
    userType: 'მომხმარებლის ტიპი',
    enabled: 'სტატუსი',
    organization: 'ორგანიზაცია',
    statusActive: 'აქტიური',
    statusDisabled: 'გაუქმებული',
    operator: 'ოპერატორი',
    admin: 'ადმინისტრატორი',
    newUser: 'ახალი მომხმარებელი',
    newUserTitle: 'ახალი მომხმარებლის რეგისტრაცია',
    create: 'შექმნა',
    modify: 'განახლება',
    errorCreatingUser: 'მომხმარებლის შექმნისას დაფიქსირდა შეცდომა',
    userCreated: 'მომხმარებელი წარმატებით შეიქმნა',
    userUpdated: 'მომხმარებელის მონაცემები განახლებულია',
    recipients: 'დაგზავნის email',
    cancel: 'გაუქმება',
    deregisterWarningTitle: 'ნამდვილად გსურთ განაცხადის დერეგისტრაცია?',
    deregisterWarningSubTitle: 'ოპერაციის გაუქმება შეუძლებელი იქნება',
    draftRemovalWarningTitle: 'ნამდვილად გსურთ დრაფტის წაშლა?',
    draftRemovalWarningSubTitle: 'ოპერაციის გაუქმება შეუძლებელი იქნება',
    notFound: 'იდენტიფიკატორი ვერ მოიძებნა',
    changeAddressWarningTitle: 'ნამდვილად გსურთ განაცხადის მისამართოს ცვლილება?',
    changeAddressWarningSubTitle: 'ოპერაციის გაუქმება შეუძლებელი იქნება',
    changeAddress: 'მისამართოს ცვლილება',
    changeAddressProgress: 'მიმდინარეობს მისამართის ცვლილება.',
    changeAddressSuccess: 'მისამართი წარმატებით შეიცვალა. განაცხადის ID - ',
    changeAddressError: 'მისამართის ცვლილებისას დაფიქსირდა შეცდომა',
}

export default function useStrings() {
    return (key: string) => appStrings[key] || key;
}